var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"cbo","rota-base":"/admin/cbo","titulo":"CBO — CLASSIFICAÇÃO BRASILEIRA DE OCUPAÇÕES","titulo-singular":"CBO","colunas-extras":[{"campo":"codigo","label":"Código CBO","tipo":"string","maxLength":10}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }